<template>
	<figure class="sanity-rich-text-component my-100 mx-0">
		<div class="grid-container">
			<img
				v-for="(item, index) in images"
				:key="index"
				:class="['grid-item', { 'grid-item-inline': index !== 0 || images.length === 2 }]"
				:src="item.url"
				:alt="item.altText ?? undefined"
			/>
		</div>
		<figcaption v-if="props.value.caption" class="figcaption">{{ props.value.caption }}</figcaption>
	</figure>
</template>

<script setup lang="ts">
import { SanityAsset, SanityImage, SanityImageLayout } from 'types/sanity';
import { computed } from 'vue';
import { generateSanityImageUrl } from '@utils/sanity/image-url-builder';
import { PortableTextComponentProps } from '@portabletext/vue';

type Props = PortableTextComponentProps<SanityImageLayout>;

const props = defineProps<Props>();

const images = computed((): Array<SanityAsset> => {
	return props.value.images.map((img) => {
		const imgUrl = (img as SanityImage).asset
			? generateSanityImageUrl(img as SanityImage)
			: (img as SanityAsset).url;

		return {
			...img,
			url: imgUrl
		};
	});
});
</script>

<style lang="scss" scoped>
@use '../../styles/utilities/respond-to.scss' as *;

figure {
	.grid-container {
		display: grid;
		gap: 1rem;
		grid-template-columns: repeat(2, 1fr);

		.grid-item {
			aspect-ratio: 16 / 9;
			grid-column: span 2;
			object-fit: cover;
		}
	}

	@include respond-to(md) {
		.grid-item.grid-item-inline {
			aspect-ratio: 4 / 3;
			grid-column: span 1;
		}
	}
}
</style>
